import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getBekleyenler } from '../services/api';

export default function BeklemOdasi() {
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const navigate = useNavigate();

  const yukle = async () => {
    try {
      const res = await getBekleyenler();
      setListe(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setYukleniyor(false);
    }
  };

  useEffect(() => { yukle(); }, []);

  const tarihFormat = (tar) => {
    if (!tar) return '';
    return new Date(tar).toLocaleDateString('tr-TR');
  };

  const bekleyenSayi = liste.filter(m => m.durum === 0).length;

  return (
    <div>
      {/* İstatistik Kartı - Sadece Bekleyen */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ background: 'var(--med-dark)', borderRadius: 'var(--radius)', padding: '12px 16px' }}>
          <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginBottom: 4 }}>⏳ Bekleyen</div>
          <div style={{ color: '#fff', fontSize: 26, fontWeight: 600 }}>{bekleyenSayi}</div>
          <div style={{ color: '#6B9FE8', fontSize: 11, marginTop: 2 }}>Şu an bekliyor</div>
        </div>
      </div>

      {/* Liste Başlığı */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <h2 style={{ fontSize: 14, fontWeight: 600 }}>Bekleyen Hastalar</h2>
        <button className="btn btn-secondary" onClick={yukle} style={{ fontSize: 12, padding: '6px 12px' }}>🔄 Yenile</button>
      </div>

      {/* Liste */}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {yukleniyor ? (
          <div className="loading">Yükleniyor...</div>
        ) : liste.length === 0 ? (
          <div className="empty">Bekleyen hasta yok</div>
        ) : (
          <>
            {/* Başlıklar */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 60px', padding: '6px 12px', background: '#f8faf9', borderBottom: '1px solid var(--border)', fontSize: 11, color: 'var(--text-muted)', fontWeight: 500 }}>
              <span>Hasta</span>
              <span>Saat</span>
            </div>

            {liste.map(m => (
              <div
                key={m.id}
                onClick={() => navigate(`/hasta/${m.kayitNo}?mprotno=${m.masterProtNo}&muayeneId=${m.id}`)}
                style={{ display: 'grid', gridTemplateColumns: '1fr 60px', padding: '8px 12px', borderBottom: '1px solid var(--border)', alignItems: 'center', cursor: 'pointer', transition: 'background 0.1s' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f8faf9'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'var(--med-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 600, color: 'var(--med-dark)', flexShrink: 0 }}>
                    {m.adSoy?.split(' ').map(n => n[0]).join('').slice(0, 2)}
                  </div>
                  <div>
                    <div style={{ fontWeight: 500, fontSize: 13 }}>{m.adSoy}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{tarihFormat(m.tar)} · #{m.kayitNo}</div>
                  </div>
                </div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{m.saat}</div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
